<script setup>
import { computed, ref, watch } from "vue";
import NotificationBar from "@/Components/NotificationBar.vue";
import { mdiCheckCircle, mdiAlert, mdiAlertCircle } from "@mdi/js";
import { usePage } from '@inertiajs/inertia-vue3';

const page = usePage();
const message = computed(() => page.props.value?.flash?.message);
const type = computed(() => page.props.value?.flash?.type || 'success');

const isAlertActive = ref(false);
let timer = null;

const triggerAlert = () => {
    if (message.value) {
        isAlertActive.value = true;
        if (timer) clearTimeout(timer);

        let seconds = 6;
        if (type.value === 'warning') seconds = 10;
        if (type.value === 'danger') seconds = 15;

        timer = setTimeout(() => {
            isAlertActive.value = false;
        }, seconds * 1000);
    } else {
        isAlertActive.value = false;
    }
};

watch(message, () => {
    triggerAlert();
}, { immediate: true });
</script>

<template>
    <div v-if="isAlertActive && message" class="fixed top-4 right-4 z-[9999] max-w-md w-full px-3 pointer-events-none transition-all duration-300">
        <div class="pointer-events-auto shadow-2xl rounded-2xl overflow-hidden">
            <NotificationBar
                :color="type || 'success'"
                :icon="(type === 'success' ? mdiCheckCircle : (type === 'warning' ? mdiAlert : mdiAlertCircle))"
                :outline="false"
                class="mb-0 p-3.5 border-0"
            >
                <div class="mr-3 font-medium text-sm text-white" v-text="message"></div>
            </NotificationBar>
        </div>
    </div>
</template>

